import { commentsData } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            观众热评
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            听听剧迷们怎么说，找到属于你的下一个心头好
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {commentsData.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-100 rounded-lg border border-background-200/60 p-5 md:p-6"
            >
              <div className="flex items-start gap-4 mb-4">
                <img
                  src={comment.avatar}
                  alt={comment.author}
                  className="w-10 h-10 rounded-full object-cover flex-shrink-0"
                  onError={(e) => {
                    (e.currentTarget as HTMLImageElement).style.display = 'none';
                  }}
                />
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-0.5">
                    <span className="text-sm font-semibold text-foreground-900">{comment.author}</span>
                    <span className="text-xs text-foreground-500">在看</span>
                    <strong className="text-xs text-primary-500 font-semibold whitespace-nowrap">
                      {comment.drama}
                    </strong>
                  </div>
                  <span className="text-xs text-foreground-400">{comment.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">&ldquo;{comment.content}&rdquo;</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}